module.exports = "/_next/static/images/9647269aee88db9911c3ff8ca3eb9572-qr-to-app-v1.svg.webp";